import { render, staticRenderFns } from "./addmenu.vue?vue&type=template&id=10b3713e&scoped=true&"
import script from "./addmenu.vue?vue&type=script&lang=js&"
export * from "./addmenu.vue?vue&type=script&lang=js&"
import style0 from "./addmenu.vue?vue&type=style&index=0&id=10b3713e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b3713e",
  null
  
)

export default component.exports